module.exports = __webpack_public_path__ + "img/18.fdf27d3a.jpg";